import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Eye, EyeSlash, LockKey } from "@phosphor-icons/react";

export const ChangePasswordDialog = ({ open, onOpenChange, trigger }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); setShow(false); };

  const submit = async () => {
    if (next.length < 8) return toast.error("New password must be at least 8 characters.");
    if (next !== confirm) return toast.error("New passwords do not match.");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed successfully.");
      reset();
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
      {trigger}
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2 font-heading"><LockKey size={20} className="text-primary" /> Change Password</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Current password</Label>
            <div className="relative mt-1">
              <Input data-testid="cp-current" type={show ? "text" : "password"} value={current} onChange={(e) => setCurrent(e.target.value)} className="rounded-xl pr-10" placeholder="••••••••" />
              <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400">{show ? <EyeSlash size={18} /> : <Eye size={18} />}</button>
            </div>
          </div>
          <div><Label>New password</Label><Input data-testid="cp-new" type={show ? "text" : "password"} value={next} onChange={(e) => setNext(e.target.value)} className="mt-1 rounded-xl" placeholder="At least 8 characters" /></div>
          <div><Label>Confirm new password</Label><Input data-testid="cp-confirm" type={show ? "text" : "password"} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1 rounded-xl" placeholder="Re-enter new password" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-xl" onClick={() => { reset(); onOpenChange(false); }}>Cancel</Button>
          <Button data-testid="cp-submit" disabled={saving || !current || !next || !confirm} className="rounded-xl bg-primary hover:bg-green-900" onClick={submit}>{saving ? "Saving…" : "Update Password"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
